import { Injectable } from '@angular/core'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class DesignerService extends ApiService {
  getPreviewData(storefrontId: number) {
    return this.get<{ preview_data: string }>(
      `${this.apiUrl}/storefronts/${storefrontId}/designer/preview `
    )
  }

  checkPagePassword(storefrontId: number, data: { password: string; page_id: string }) {
    return this.post(`${this.apiUrl}/storefronts/${storefrontId}/page/verify-password `, data)
  }
}
